import React, { Fragment } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Time from "./Time";

const AnsweringInfo = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const answeringInfo = useSelector( state => state.answeringInfo );

  const { t } = useTranslation();

  const { Timer } = props;

  return (
    <div className="barBox">
      <div className="bar2">
        <div className={ clsx( 'upper', answeringInfo.accuracyMessage && 'green' ) }>
          { `${ t( 'LC_02_06.msg002' ) } ${ answeringQuestions.data.accuracy || 0 }% ${ answeringInfo.accuracyMessage }` }
        </div>
        <div className="lower">
          <div className="bar_bg">
            <div className="bar" style={ { width : `${ answeringQuestions.data.accuracy || 0 }%` } } />
          </div>
          <Timer><Time /></Timer>
        </div>
      </div>
    </div>
  );

};

AnsweringInfo.defaultProps = {
  Timer : Fragment
};

export default AnsweringInfo;
